import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import styles from 'components/SidebarNav/sidebar-nav.module.scss'
import { Button, Grid, Icon } from 'gu-ui-kit'
import { useSelector } from 'react-redux'
import Logo from 'layouts/subcomponents/Logo'
import Nav from 'components/Nav'
import defaultNavigationConfig from 'constants/default-navigation'
import { useLocation } from 'react-router'

const SidebarNav = () => {
  const { auth } = useSelector(({ auth }) => auth)
  const { user } = useSelector(({ app }) => app)
  const [open, setOpen] = useState(false)
  const config = defaultNavigationConfig({ user })

  const location = useLocation()

  useEffect(() => {
    setOpen(false)
  }, [location])

  useEffect(() => {
    const toggleListener = () => {
      setOpen(!open)
      document.querySelector('body').classList.toggle('body_overflow_hidden')
    }

    global.addEventListener('sidebar:toggle', toggleListener)

    return () => {
      global.removeEventListener('sidebar:toggle', toggleListener)
    }
  }, [])

  const toggleSideBar = useCallback(() => {
    setOpen(!open)
    document.querySelector('body').classList.toggle('body_overflow_hidden')
  }, [open])

  return !auth ? null : (
    <OutsideClickHandler onOutsideClick={(e) => open && toggleSideBar(e)}>
      <span
        className={clsx(styles['sidebar'], {
          [styles['sidebar_open']]: open,
        })}
      >
        <div
          onClick={(e) => {
            if (!e.target.classList.contains(styles['overflow-container'])) {
              return false
            }

            toggleSideBar()
          }}
          className={styles['overflow-container']}
        >
          <div className={styles['content']}>
            <Grid
              alignItems={'center'}
              justifyContent={'between'}
              className={styles['header']}
            >
              <Logo />

              <Button
                onClick={toggleSideBar}
                grey
                variant={'ghost'}
                size={'m'}
                noLabel
                startIcon={<Icon name={'close'} />}
                className={styles['sidebar__close-button']}
              />
            </Grid>

            <Grid direction={'column'} gap={16} className={'margin-top-32'}>
              <Nav items={config} />
            </Grid>
          </div>
        </div>
      </span>
    </OutsideClickHandler>
  )
}

SidebarNav.propTypes = {
  nonSPA: PropTypes.bool,
}

export default SidebarNav
